<div class="panel__content no-padding">
  <table class="table--striped table--hover" >

      <thead>
          <tr>
              <th >Model</th>
              <th >Unit #</th>
              <th >Serial #</th>
              <th >Implement #</th>
              <th >Date</th>
              <th >Action</th>
              <th >Hours</th>
              <th>Hrs Diff</th>
              <th >BCM</th>
              <th >Tons</th>
              <th >Cost</th>
              <th >Comment</th>
              <th >Repairer </th>
              <th >Location</th>
             
          </tr>
      </thead>
      <tbody style="font-size: smaller;">
          <ng-container *ngFor="let OP of historyDetails_">
              <tr>
                  <td class="CelltextWrap columncell" >{{OP.Model}}</td>
                  <td class="CelltextWrap columncell" >{{OP.Unit}}</td>
                  <td class="columncell">{{OP.Serial}}</td>
                  <td class="columncell">{{OP.ImplementName}}</td>
                  <td class="columncell">{{OP.ActionDate | date : 'dd-MMM-yyyy'}}</td>
                  <td>{{OP.ActionName}}</td>
                  <td>{{OP.Hours }}</td>
                  <td>{{OP.HoursDiff }}</td>
                  <td>{{OP.BCM}}</td>
                  <td>{{OP.Tons}}</td>
                  <td>{{OP.Cost}}</td>
                  <td>{{OP.comment}}</td>
                  <td>{{OP.Repairer}}</td>
                  <td>{{OP.Location}}</td>
          </ng-container>
      </tbody>
  </table>
</div>